<template>
  <div class="row containerspa">
    <div class="col-xs-12 col-sm-12 col-md-12 noPadding">
      <sub-menu-bar :pcSubPageMenu="pcSubPageMenu" @subpagemenu="subpagemenu"></sub-menu-bar>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 page-right">
      <!-- <keep-alive exclude="SearchPage,SearchListPage"> -->
      <keep-alive>
        <router-view/>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import subMenuBar from '@/components/subMenuBarSpa/subMenuBar'
export default {
  components: {
    subMenuBar,
  },
  data () {
    return {
      pcSubPageMenu: this.globalmenu.exhibitor,
      pcShow: false,
    }
  },
  methods: {
    subpagemenu(item){
      this.$router.push({
        name: item.pathName,
        query: {
          name: item.subName,
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.page-right{
  margin-top: 2%;
  min-height: 500px;
}
@media (min-width: 320px) and (max-width: 767px){
  .page-right{
    min-height: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/ExhibitorSpa/main.vue